import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SubscriptionStatus from '../components/SubscriptionStatus';

const Dashboard: React.FC = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Dashboard",
      welcome: "Welcome to your dashboard"
    },
    da: {
      title: "Dashboard",
      welcome: "Velkommen til dit dashboard"
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-20 pb-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h1 
              className="text-3xl md:text-4xl font-serif font-bold mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {content[language as keyof typeof content].title}
            </h1>
            <p className="text-lg text-gray-600">
              {content[language as keyof typeof content].welcome}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <SubscriptionStatus language={language} />
            
            {/* Add more dashboard components here */}
            <div className="bg-white rounded-lg shadow-sm border p-6">
              <h3 className="text-lg font-semibold mb-4">Recent Orders</h3>
              <p className="text-gray-600">No recent orders</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;